// src/components/StatCard.jsx
import React from "react";
import { Card, CardBody } from "reactstrap";

function StatCard({ title, value, subtitle, color = "#1D67AA", Icon }) {
  return (
    <Card
      style={{
        border: "1px solid #E5E7EB",
        
        height: "100%",
      }}
    >
      <CardBody
        style={{
          padding: "10px 20px",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent:"center",
          gap: "4px",
        }}
      >
        {/* icon top‑right */}
        {Icon && (
          <Icon
            size={18}
            style={{ position: "absolute", top: 16, right: 16, color }}
          />
        )}

        <span
          style={{
            fontSize: "14px",
            fontWeight: 500,
            color: "#3C3C3C",
          }}
        >
          {title}
        </span>

        <span
          style={{
            fontSize: "24px",
            fontWeight: 700,
            color,
            lineHeight: 1.1,
          }}
        >
          {value}
        </span>

        <span
          style={{
            fontSize: "12px",
            color: "#6C6C6C",
          }}
        >
          {subtitle}
        </span>
      </CardBody>
    </Card>
  );
}

export default StatCard;
